
export class DebounceService {

    _eventTimer: any

    executeEvent(event: () => void, delay: number = 100) {
        clearTimeout(this._eventTimer);
        this._eventTimer = setTimeout(() => {
            event();
        }, delay);
    }
}
